module.exports = __webpack_public_path__ + "static/media/13-web-or-mls-DSC06565.d0e93f9c.jpg";